// extracted by mini-css-extract-plugin
export var form = "_cb-0";